<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.paymentDetails &&
    _vm.paymentDetails.sellerPaymentMethodInfo &&
    _vm.paymentDetails.sellerPaymentMethodInfo.id
    ? _c(
        "div",
        { staticClass: "border rounded pr-2 pl-2 pb-2 mt-2" },
        [
          _vm.paymentDetails.orderType === "BUY"
            ? _c("div", { staticClass: "payment-show mt-1" }, [
                _c(
                  "div",
                  { staticClass: "payment-method d-inline-block mr-2" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("orderCreated.Payment-Method")) + " "
                    ),
                  ]
                ),
                _c("div", { staticClass: "payment-name" }, [
                  _c("div", {
                    staticClass: "vertical-red-line",
                    style: {
                      border:
                        _vm.paymentDetails.sellerPaymentMethodInfo.config &&
                        _vm.paymentDetails.sellerPaymentMethodInfo.config
                          .uiColour
                          ? "2px solid " +
                            _vm.paymentDetails.sellerPaymentMethodInfo.config
                              .uiColour
                          : "2px solid #8dc540",
                    },
                  }),
                  _c("div", { staticClass: "d-inline" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.paymentDetails.sellerPaymentMethodInfo
                            .paymentMethod
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.paymentDetails.orderType === "SELL" &&
          ["CREATED", "PAYMENT_SENT"].includes(_vm.paymentDetails.orderStatus)
            ? _c("div", { staticClass: "payment-show mt-1" }, [
                _c(
                  "div",
                  { staticClass: "payment-method d-inline-block mr-2" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("orderCreated.VerifyPaymentFromUser", {
                            user: _vm.paymentDetails.username,
                          })
                        ) +
                        " "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.paymentDetails.orderType === "SELL"
            ? _c("div", { staticClass: "mt-1 d-flex justify-content-start" }, [
                _c("div", [
                  _c("div", { staticClass: "profile-amt no-wrap" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("orderCreated.YourAccountDetails")) +
                        " "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.paymentDetails.orderType === "SELL"
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-between mt-1" },
                [
                  _c("div", [
                    _c("div", { staticClass: "profile-text" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("orderCreated.Payment-Method")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "profile-amt no-wrap" }, [
                    _c("div", {
                      staticClass: "vertical-red-line",
                      style: {
                        border:
                          _vm.paymentDetails.sellerPaymentMethodInfo.config &&
                          _vm.paymentDetails.sellerPaymentMethodInfo.config
                            .uiColour
                            ? "2px solid " +
                              _vm.paymentDetails.sellerPaymentMethodInfo.config
                                .uiColour
                            : "2px solid #8dc540",
                      },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.paymentDetails.sellerPaymentMethodInfo
                            .paymentMethod
                        ) +
                        " "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._l(_vm.paymentFields, function (item, index) {
            return _c(
              "div",
              { staticClass: "d-flex justify-content-between mt-1" },
              [
                _c("div", [
                  _c("div", { staticClass: "profile-text" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                ]),
                _c("div", [
                  item.id !== "qrcode.doc"
                    ? _c(
                        "div",
                        { staticClass: "profile-amt no-wrap" },
                        [
                          _vm._v(" " + _vm._s(item.value) + " "),
                          _c("Copy", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.v-primary",
                                modifiers: { hover: true, "v-primary": true },
                              },
                            ],
                            staticClass: "pointer copy_icon",
                            attrs: { title: _vm.$t("wallet.Copy") },
                            on: {
                              click: function ($event) {
                                return _vm.copy(item.value)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "profile-amt" },
                        [
                          _c("b-img", {
                            staticClass: "pointer",
                            staticStyle: { "max-width": "45px" },
                            attrs: { src: item.value },
                            on: {
                              click: function ($event) {
                                return _vm.showImage(true, item.value, "image")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                ]),
              ]
            )
          }),
          _c("ImagePreview", {
            attrs: {
              showPop: _vm.showDocumentPreviewModal,
              onModalHidden: _vm.showImage,
              url: _vm.url,
              documentType: _vm.type,
            },
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/amount-section/PaymentInfo.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import * as vuex from 'vuex';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import utils_clipboard from '@/utils/clipboard';
import layouts_components_ImagePreview_vue from '@/layouts/components/ImagePreview.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






export default ({
  render,
  staticRenderFns,
  components: {
    BImg: bootstrapvue["BImg"],
    Copy: assets_rashi_coin_copy_svg,
    ImagePreview: layouts_components_ImagePreview_vue
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  props: {
    paymentDetails: {
      type: Object,
      isRequired: false,
      default: () => {}
    }
  },
  data() {
    return {
      paymentFields: [],
      showImagePop: false,
      popImage: "",
      showDocumentPreviewModal: false,
      url: "",
      type: ""
    };
  },
  computed: {
    ...vuex.mapState("user", ["refData"])
  },
  watch: {
    refData(newVal) {
      this.findPaymentMethod();
    },
    paymentDetails(newVal) {
      this.findPaymentMethod();
    }
  },
  mounted() {
    this.findPaymentMethod();
  },
  methods: {
    showImage(flag, url, type) {
      this.showDocumentPreviewModal = flag;
      if (flag) {
        this.url = url;
        this.type = type;
      } else {
        this.url = "";
        this.type = "";
      }
    },
    async copy(text) {
      await utils_clipboard.apply(this, [`${text}`]);
    },
    openQr(url) {
      this.popImage = url;
    },
    findPaymentMethod() {
      if (this.paymentDetails && this.paymentDetails.sellerPaymentMethodInfo && this.paymentDetails.sellerPaymentMethodInfo.paymentMethod && this.refData && this.refData.countryData && this.refData.countryData.paymentMethods && this.refData.countryData.paymentMethods.length) {
        const foundObject = this.refData.countryData.paymentMethods.find(obj => obj.id === this.paymentDetails.sellerPaymentMethodInfo.paymentMethod);
        this.mapFields(foundObject.fields);
      }
    },
    mapFields(fields) {
      this.qrIsRequired = false;
      this.paymentFields = fields.map(field => {
        let value = this.paymentDetails.sellerPaymentMethodInfo[field.id] || null;
        if (field.id === "qrcode.doc") {
          this.qrIsRequired = field.isRequired;
          value = this.paymentDetails.sellerPaymentMethodInfo.accountQrcodeUrl || null;
        }
        return {
          ...field,
          value
        };
      }).filter(field => {
        // Hide qrcode.doc row if no QR image URL is available
        if (field.id === "qrcode.doc" && !field.value) {
          return false;
        }
        return true;
      }) || [];
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/amount-section/PaymentInfo.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.profile-text {
  color: #686e7d;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.profile-amt {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: var(--1e2329);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
.profile-amt-green {
  display: flex;
  justify-content: flex-end;
  color: #8dc540;
  font-size: 21px;
  font-weight: 700;
  line-height: 32px;
}
.payment-show {
  display: flex;
  align-items: center;
}
.vertical-red-line {
  display: inline-block;
  width: 2px;
  height: 12px;
  /* border: 2px solid #f7984a; */
  /* background: #f7984a; */
}
[dir] .vertical-red-line {
  margin: 0px 5px 0px 5px;
  border-radius: 4px;
}
.payment-method {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 600;
  line-height: 24px;
}
[dir=ltr] .copy_icon {
  margin-left: 6px;
}
[dir=rtl] .copy_icon {
  margin-right: 6px;
}
.copy_icon path {
  fill: var(--primary);
}
</style>
